import { Observable } from 'rxjs/Observable';
import { AppConfig } from '../../app/app.config';
import { Facade } from '../../core/facades/facade';
import { VASRestService } from '../../core/services/api/vas-rest';
import { SyncDownEndEvent, SyncDownStartEvent } from '../../core/system/system.actions';
import { SyncDownService } from '../services/sync-down/sync-down.service';
import { VasAppFacade } from '../services/vas-app-facade.service';

export class SyncDownFacade extends Facade {

    protected service: SyncDownService;

    protected ENTITY_SYNC_DOWN_LIST;

    constructor(
        protected appFacade: VasAppFacade,
        protected api: VASRestService,
        protected config: AppConfig
    ) {
        super(appFacade);

        this.ENTITY_SYNC_DOWN_LIST = config.ENTITY_SYNC_DOWN_LIST;

        this.service = new SyncDownService(
            this.appFacade, api,
            this.ENTITY_SYNC_DOWN_LIST
        );

        this.service.error$.subscribe(error => {
            this.appFacade.toast.toastDanger(error);
        });
    }

    get busy$(): Observable<boolean> {
        return this.service.active$;
    }

    init(): void {
        this.service.init();
    }

    sync(accountId: string): Observable<any> {

        if (!accountId) {
            return;
        }

        return this.appFacade.objects.config.store
            .getLastSyncDownDate(accountId)
            .take(1)
            .concatMap(date =>
                date ? this.syncRefresh(accountId) : this.syncFull(accountId)
            );
    }

    async syncFull(accountId: string): Promise<any> {

        if (!accountId) {
            return;
        }

        const options = this.service.prepareSyncDownOptions({
            accountId
        });

        this.appFacade.triggerSystemEvent(new SyncDownStartEvent());
        await this.appFacade.loading.showLoading();
        await this.appFacade.network.refreshStatusP();
        try {
            await this.service.syncFull(options);
        } catch (e) {
            // ignore
        }
        await this.appFacade.loading.hideLoading();
        this.appFacade.triggerSystemEvent(new SyncDownEndEvent());

    }

    async forceSyncFull(accountId: string): Promise<any> {

        if (!accountId) {
            return;
        }

        const options = this.service.prepareSyncDownOptions({
            accountId,
            force: true
        });
        this.appFacade.triggerSystemEvent(new SyncDownStartEvent());
        await this.appFacade.loading.showLoading();
        await this.appFacade.network.refreshStatusP();
        try {
            await this.service.syncFull(options);
        } catch (e) {
            // ignore
        }

        await this.appFacade.loading.hideLoading();
        this.appFacade.triggerSystemEvent(new SyncDownEndEvent());
    }

    async syncRefresh(accountId: string): Promise<any> {

        if (!accountId) {
            return;
        }

        const lastSyncDown = await this.service.getLastSyncTime(accountId);

        if (!lastSyncDown) {
            return this.syncFull(accountId);
        }

        const options = this.service.prepareSyncDownOptions({
            accountId
        });

        this.appFacade.triggerSystemEvent(new SyncDownStartEvent());
        await this.appFacade.network.refreshStatusP();
        try {
            await this.service.syncRefresh(options);
        } catch (e) {
            // ignore
        }
        await this.appFacade.triggerSystemEvent(new SyncDownEndEvent());
    }

    stop(): void {
        return this.service.stop();
    }
}



// WEBPACK FOOTER //
// ./src/vas/facades/sync-down-facade.ts